import { render, staticRenderFns } from "./information-form-candidate.vue?vue&type=template&id=49b969d4&scoped=true&"
import script from "./information-form-candidate.vue?vue&type=script&lang=js&"
export * from "./information-form-candidate.vue?vue&type=script&lang=js&"
import style0 from "./information-form-candidate.vue?vue&type=style&index=0&id=49b969d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b969d4",
  null
  
)

export default component.exports